import { Module } from 'vuex'

import TariffService from './modules/TariffsServise/TariffService'

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
export default {
  namespaced: true,

  modules: {
    TariffService,
  },
} as Module<string, any>
